
import React, { useEffect } from 'react'
import { Navigate, Route } from 'react-router-dom'

function PrivateRoute({children, token}) {

  useEffect(() => {
    console.log(children)
  }, [token, children])
  return (
    token ? children : <Navigate to="/login" />

  );
}

export default PrivateRoute